import { useNavigate } from 'react-router-dom';
import { ForecasterLogo } from '../ForecasterLogo';

export const FooterSection = () => {
    const navigate = useNavigate();

    return (
        <footer className="py-12 md:py-16 px-4 sm:px-6 border-t border-white/5 bg-obsidian-950">
            <div className="max-w-6xl mx-auto">
                <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8">
                    <div className="sm:col-span-2">
                        <ForecasterLogo />
                        <p className="text-gray-300 mt-4 max-w-md text-sm">
                            The inference intelligence layer. Schedule. Route. Cache. Scale. Observe — across every GPU, every cloud.
                        </p>
                    </div>
                    <div>
                        <h4 className="text-white font-bold mb-4 text-sm">Product</h4>
                        <div className="space-y-2">
                            <button onClick={() => navigate('/pricing')} className="block text-gray-300 hover:text-white transition text-sm">Pricing</button>
                            <button onClick={() => navigate('/compare')} className="block text-gray-300 hover:text-white transition text-sm">Compare</button>
                            <button onClick={() => navigate('/security')} className="block text-gray-300 hover:text-white transition text-sm">Security</button>
                            <button onClick={() => navigate('/trial')} className="block text-gray-300 hover:text-white transition text-sm">Start Trial</button>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-white font-bold mb-4 text-sm">Legal</h4>
                        <div className="space-y-2">
                            <button onClick={() => navigate('/privacy')} className="block text-gray-300 hover:text-white transition text-sm">Privacy</button>
                            <button onClick={() => navigate('/terms')} className="block text-gray-300 hover:text-white transition text-sm">Terms</button>
                        </div>
                    </div>
                </div>
                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-gray-400">© 2026 Forecaster. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};
